module.exports = __webpack_public_path__ + "static/img/logo5.f481b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/logo5.png
// module id = t4OC
// module chunks = 0